import {
  useQuery, UseQueryResult, useInfiniteQuery, UseInfiniteQueryResult,
} from '@tanstack/react-query';
import { getVehicles } from '../../services/VehiclesService';
import { VehiclesResponse } from '../../types/Vehicles';
import { FeaturesManagement } from '../../../featuresControl';

function useGetVehicles(fleetId: string, query: string, enabled: boolean = true): UseQueryResult<VehiclesResponse> {
  return useQuery(
    ['vehicles', fleetId, query],
    async (): Promise<VehiclesResponse> => getVehicles(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled,
    },
  );
}

export function useGetVehiclesLazy(fleetId: string, payload?: any, query?: string, deps?: any): UseInfiniteQueryResult<VehiclesResponse> {
  return useInfiniteQuery(
    ['vehicles-lazy', fleetId, deps],
    async ({ pageParam = query }): Promise<VehiclesResponse> => getVehicles(fleetId, pageParam),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage) => (lastPage?.total ? ((lastPage.limit + lastPage.skip + 1) < lastPage.total) : undefined),
    },
  );
}

export default useGetVehicles;
